import React, { useContext, useState } from 'react';
import { Accordion, AccordionSummary, Typography, AccordionDetails } from '@mui/material';
import { isMobile, isIpad, isDesktop } from '../../utils/ScreenSizeHelper';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { GlobalStateDataContext } from '../../context-api/data-provider/GlobalStateDataProvider';
import { OrderDataProviderContext } from '../../context-api/data-provider/OrderDataProvider';
import { orderStatusMapping } from '../../utils/constants';
import Loader from '../../composed/loader/Loader';
import { Avatar } from '@mui/material';
import OtpVerify from '../../composed/otpverify/OtpVerify';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import DoNotTouchIcon from '@mui/icons-material/DoNotTouch';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import RunCircleIcon from '@mui/icons-material/RunCircle';
import TextTransformation from '../../utils/textTransformation';
import PrintReceipt from '../../composed/printReceipt/PrintReceipt';
import { getFriendlyDateLabel } from '../../utils/dateFormat';
import NoOrderFound from './NoOrderFound';

const ReadyOrder = () => {
  const { isLoggedIn, orderReadyForPickup, setOrderReadyForPickup, openSnackBar, setOpenSnackBar } =
    useContext(GlobalStateDataContext);

  const [otp, setOTP] = useState([]);
  const [optDisabled, setOptDisabled] = useState(false);

  const {
    onUpdateOrderStatus,
    updateOrderAPIResponse,
    setUpdateOrderAPIResponse,
    clickedOrderReady,
    setClickedOrderReady,
  } = useContext(OrderDataProviderContext);

  const [startNo, endNo] = (clickedOrderReady?.order_no || '').split('-');
  const isMealOrder = endNo?.includes('MEAL');
  const driverOTPNo = clickedOrderReady?.driver_information?.otp_driver?.toString();

  const DriverOneTheWay = clickedOrderReady?.internal_order_status === 'driver pickup pending';
  const DriverFirstName = clickedOrderReady?.driver_information?.first_name;
  const DriverLastName = clickedOrderReady?.driver_information?.last_name;
  const ProfileImage = clickedOrderReady?.driver_information?.driver_profile_picture;
  const DeliveryOrderOne = clickedOrderReady?.delivery_type === 'home delivery';
  const PickUpOrderOne = clickedOrderReady?.delivery_type === 'pickup';

  const promoTypeLabel = (discount_type, discountedAmount) => {
    // You have to create paths on app.js before coming here to add tan name
    switch (discount_type) {
      case 'percentage':
        return `${discountedAmount}% off`;
      case 'plates':
        return `${discountedAmount} Free meal`;
      case 'amount_off':
        return `- $${discountedAmount} off`;
      case 'product':
        return `- $${discountedAmount} off`;
      case 'free_delivery':
        return `- $${discountedAmount} Delivery off`;
      case 'percentage_delivery':
        return `${discountedAmount}% Delivery off`;
      case 'free':
        return `Free order`;
    }
  };

  const StyleTotalBlock = {
    fontFamily: 'Inter Medium',
    fontSize: '15px',
  };

  const StyleNumberBlock = {
    fontFamily: 'Inter Medium',
    fontSize: '15px',
  };

  if (orderReadyForPickup?.length <= 0) {
    return <NoOrderFound />;
  }

  return (
    <div style={{ display: 'flex', height: '96vh' }}>
      <div
        style={{
          width: '35%',
          borderRight: '1px solid #ccd0d5',
          // backgroundColor: 'rgb(254, 247, 200)',
        }}
      >
        {orderReadyForPickup.map((item) => {
          const [startNo, endNo] = item.order_no.split('-');
          const totalItems = item?.item_names?.length;
          const mealTotalItems = item?.item_name?.length;
          const DriverOneTheWay = item.internal_order_status === 'driver pickup pending';
          const DriverFirstName = item.driver_information?.first_name;
          const DriverLastName = item.driver_information?.last_name;
          const ProfileImage = item.driver_information?.driver_profile_picture;
          const DeliveryOrder = item?.delivery_type === 'home delivery';
          const InHouseDelivery = item?.delivered_by === 'kitchen';
          const PickUpOrder = item?.delivery_type === 'pickup';

          return (
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                // alignItems: 'center',
                alignItems: 'center',
                justifyContent: 'space-between',
                height: 'auto',
                borderRadius: '3px',
                margin: '4px',
                padding: '10px 10px 20px 10px',
                backgroundColor: 'rgb(232, 232, 232)',
                color: '#1E3E62',
                cursor: 'pointer',
              }}
              onClick={() => {
                setClickedOrderReady(item);
              }}
            >
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <div
                  style={{
                    fontSize: '16px',
                    fontFamily: 'Inter Bold',
                    textTransform: 'capitalize',
                    letterSpacing: '0.5px',
                    marginBottom: '10px',
                  }}
                >
                  {' '}
                  {item.cust_firstName}
                </div>

                <div style={{ fontFamily: 'Inter Regular', fontSize: '14px' }}> {`# ${endNo}`}</div>
                <div style={{ fontFamily: 'Inter Regular', fontSize: '14px' }}>
                  {' '}
                  {totalItems || mealTotalItems}{' '}
                  {totalItems === 1 || mealTotalItems === 1 ? 'item' : 'items'}{' '}
                </div>
              </div>

              {DriverOneTheWay === true && DeliveryOrder && (
                <div
                  style={{
                    display: 'flex',
                    // flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    border: '1px solid #1E3E62',
                    backgroundColor: 'rgb(255, 123, 41)',
                    borderRadius: '3px',
                    padding: '10px',
                    color: '#1E3E62',
                    height: '30px',
                    width: 'auto',
                  }}
                >
                  <Avatar alt='Remy Sharp' src={ProfileImage} sx={{ width: 32, height: 32 }} />
                  <div style={{ display: 'flex', flexDirection: 'column', marginLeft: '10px' }}>
                    <div
                      style={{
                        fontFamily: 'Inter Bold',
                        fontSize: '14px',
                        textTransform: 'capitalize',
                        color: 'white',
                      }}
                    >
                      {' '}
                      {DriverFirstName}
                    </div>
                    <div style={{ fontSize: '12px', color: 'white' }}>
                      {orderStatusMapping[item.internal_order_status]}
                    </div>
                  </div>
                </div>
              )}

              {DriverOneTheWay === false && DeliveryOrder && (
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                >
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      border: '1px solid #1E3E62',
                      backgroundColor: '#81E7AF',
                      fontSize: '12px',
                      borderRadius: '3px',
                      padding: '5px',
                      color: '#1E3E62',
                      textTransform: 'uppercase',
                      height: '30px',
                      width: 'auto',
                    }}
                  >
                    <div style={{ marginRight: '10px' }}>
                      <Loader color='black' width='20px' height='20px' />
                    </div>
                    <div>{orderStatusMapping[item.internal_order_status]}</div>
                  </div>
                  {InHouseDelivery && (
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        border: '2px solid #1E3E62',
                        backgroundColor: '#ffffffff',
                        marginTop: '5px',
                        fontSize: '12px',
                        borderRadius: '3px',
                        padding: '5px',
                        color: '#1E3E62',
                        textTransform: 'uppercase',
                        height: '30px',
                        width: '170px',
                      }}
                    >
                      Assign Drive
                    </div>
                  )}
                </div>
              )}

              {PickUpOrder && (
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    border: '1px solid #1E3E62',
                    backgroundColor: '#ffffffff',
                    marginTop: '5px',
                    fontSize: '12px',
                    borderRadius: '3px',
                    padding: '5px',
                    color: '#1E3E62',
                    textTransform: 'uppercase',
                    height: '30px',
                    width: '171px',
                  }}
                >
                  <a style={{ display: 'flex', alignItems: 'center', marginTop: '0px' }}>
                    <RunCircleIcon
                      sx={{ color: '#181436', fontSize: '25px', margin: '0px 5px 0px 0px' }}
                    />{' '}
                    <a style={{ fontSize: '15px' }}>Pickup</a>
                  </a>
                </div>
              )}
            </div>
          );
        })}
      </div>

      {Object.keys(clickedOrderReady).length > 0 && (
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            // justifyContent: 'center',
            marginTop: '20px',
            width: '50%',
            backgroundColor: 'white',
            borderLeft: '1px solid #ccd0d5',
          }}
        >
          {DeliveryOrderOne && (
            <>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  width: '100px',
                  height: '100px',
                  border: '1px solid black',
                  borderRadius: '50px',
                  marginBottom: '10px',
                }}
              >
                <Loader color='black' width='30px' height='30px' />
              </div>
              <div>...{orderStatusMapping[clickedOrderReady.internal_order_status]}</div>
            </>
          )}
          {DeliveryOrderOne && (
            <div
              style={{
                color: 'rgb(24, 20, 54)',
                border: '1px solid rgb(149, 237, 135)',
                backgroundColor: 'rgb(149, 237, 135)',
                padding: '5px 10px 5px 10px',
                borderRadius: '3px',
                fontFamily: 'Inter Regular',
                marginTop: '10px',
                fontSize: '14px',
                letterSpacing: '0.5px',
              }}
            >
              {' '}
              'In-Store Delivery'
            </div>
          )}
          {PickUpOrderOne && (
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                border: '2px solid #1E3E62',
                backgroundColor: '#ffffffff',
                marginTop: '5px',
                fontSize: '12px',
                borderRadius: '3px',
                padding: '5px',
                color: '#1E3E62',
                textTransform: 'uppercase',
                height: '30px',
                width: '171px',
              }}
            >
              <a style={{ display: 'flex', alignItems: 'center', marginTop: '0px' }}>
                <RunCircleIcon
                  sx={{ color: '#181436', fontSize: '25px', margin: '0px 5px 0px 0px' }}
                />{' '}
                <a style={{ fontSize: '15px' }}>Pickup</a>
              </a>
            </div>
          )}
          {DriverOneTheWay === true && (
            <>
              <Avatar alt='Remy Sharp' src={ProfileImage} sx={{ width: 100, height: 100 }} />
              <div
                style={{
                  fontFamily: 'Inter Bold',
                  fontSize: '14px',
                  textTransform: 'capitalize',
                  color: 'black',
                  margin: '10px 0px 0px 0px',
                }}
              >
                {' '}
                {DriverFirstName}
              </div>
              <div
                style={{
                  fontSize: '16px',
                  color: 'rgb(255, 123, 41)',
                }}
              >
                {orderStatusMapping[clickedOrderReady.internal_order_status]}
              </div>
            </>
          )}
          <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
            <div
              style={{ fontFamily: 'Inter Bold', fontSize: '28px', margin: '15px 30px 15px 0px' }}
            >
              {' '}
              {endNo?.slice(-5)}
            </div>
            <PrintReceipt data={clickedOrderReady} color={'rgb(255, 123, 41)'} size={'28px'} />
          </div>
          {DriverOneTheWay === true && (
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                width: '200px',
              }}
            >
              <div
                style={{
                  fontSize: '20px',
                  fontFamily: 'Inter Medium',
                  margin: '10px 0px 10px 0px',
                }}
              >
                {' '}
                Verify Driver OTP
              </div>
              <OtpVerify digits={4} otp={otp} setOTP={setOTP} setDisabled={setOptDisabled} />
              {otp === driverOTPNo ? (
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    marginTop: '10px',
                    color: 'green',
                  }}
                >
                  <CheckCircleOutlineIcon style={{ color: 'green' }} /> Verified Driver{' '}
                </div>
              ) : (
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    marginTop: '10px',
                    color: 'red',
                  }}
                >
                  {' '}
                  <DoNotTouchIcon style={{ color: 'red' }} /> Driver not verified
                </div>
              )}
            </div>
          )}
          <div
            style={{
              margin: '10px',
            }}
          >
            <Accordion style={{ width: '450px' }}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls='panel1-content'
                id='panel1-header'
              >
                <div
                  style={{
                    textTransform: 'capitalize',
                    color: 'rgb(24, 20, 54',
                    fontSize: '16px',
                    fontFamily: 'Inter Bold',
                    marginRight: '20px',
                  }}
                >
                  {clickedOrderReady?.cust_firstName}
                </div>
                <div
                  style={{
                    fontSize: '16px',
                    fontFamily: 'Inter Regular',
                  }}
                >
                  {' '}
                  Order No : {endNo}{' '}
                </div>
              </AccordionSummary>
              <AccordionDetails>
                <div
                  style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}
                >
                  <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <div style={{ fontFamily: 'Inter Regular', fontSize: '14px' }}> Date</div>
                    <div style={{ fontFamily: 'Inter Bold', fontSize: '14px' }}>
                      {' '}
                      {getFriendlyDateLabel(clickedOrderReady?.delivery_date)}
                    </div>
                  </div>

                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                    }}
                  >
                    {clickedOrderReady?.delivery_type === 'home delivery' && (
                      <a style={{ display: 'flex', alignItems: 'center', marginTop: '5px' }}>
                        <LocalShippingIcon
                          sx={{ color: '#181436', fontSize: '25px', margin: '0px 5px 0px 0px' }}
                        />{' '}
                        <a style={{ fontSize: '15px' }}>Home Delivery</a>
                      </a>
                    )}

                    {clickedOrderReady?.delivery_type === 'pickup' && (
                      <a style={{ display: 'flex', alignItems: 'center', marginTop: '5px' }}>
                        <RunCircleIcon
                          sx={{ color: '#181436', fontSize: '25px', margin: '0px 5px 0px 0px' }}
                        />{' '}
                        <a style={{ fontSize: '15px' }}>Pickup</a>
                      </a>
                    )}
                  </div>
                </div>

                <div style={{ display: 'flex', flexDirection: 'column', marginTop: '10px' }}>
                  <div style={{ fontSize: '13px', fontFamily: 'Inter Regular' }}>Delivery slot</div>
                  <div style={{ fontSize: '14px', fontFamily: 'Inter Bold' }}>
                    {' '}
                    {clickedOrderReady?.delivery_time_slot}
                  </div>
                </div>

                {isMealOrder === false && Object.keys(clickedOrderReady).length > 0 && (
                  <div style={{ marginTop: '20px' }}>
                    <div
                      style={{
                        marginLeft: '10px',
                        fontFamily: 'Roboto',
                        fontSize: '14px',
                        color: '#929293',
                      }}
                    >
                      Item{clickedOrderReady?.item_names?.length > 1 ? 's' : ''}
                    </div>
                    <div style={{ margin: '10px 10px 10px 15px', alignContent: 'center' }}>
                      {clickedOrderReady?.item_names?.map((item, i) => {
                        let price = 'Meal item';
                        let isMealItem = false;

                        if (item?.price) {
                          price = item.qty * item.price;
                        }

                        if (item?.product_category) {
                          isMealItem = true;
                        }

                        const displayPrice = price === 'Meal item' ? 'Meal item' : `$${price}`;

                        if (
                          item?.promotion === 'buy_one_get_one_free' &&
                          price !== 'Meal item' &&
                          item.qty > 1
                        ) {
                          price = (item.qty - Math.floor(item.qty / 2)) * item.price;
                        } else if (
                          item?.promotion === 'buy_two_get_one_free' &&
                          price !== 'Meal item' &&
                          item.qty > 2
                        ) {
                          price = (item.qty - Math.floor(item.qty / 3)) * item.price;
                        } else if (
                          item?.promotion === 'buy_one_get_half_price' &&
                          price !== 'Meal item' &&
                          item.qty > 1
                        ) {
                          price =
                            (item.qty - Math.floor(item.qty / 2) + Math.floor(item.qty / 2) / 2) *
                            item.price;
                        }

                        return (
                          <div
                            style={{ alignContent: 'center', marginBottom: '10px' }}
                            key={`${item}_${i}`}
                          >
                            <div
                              style={{
                                display: 'flex',
                                flexDirection: 'row',
                                alignText: 'center',
                                alignContent: 'center',
                              }}
                            >
                              <div
                                style={{
                                  display: 'flex',
                                  fontFamily: 'Roboto Medium',
                                  fontSize: '11px',
                                  justifyContent: 'center',
                                  backgroundColor: '#e8e7e9',
                                  alignItems: 'center',
                                  border: '1px solid #c7c7c7',
                                  borderRadius: '3px',
                                  height: '18px',
                                  width: '22px',
                                  margin: '0px 10px 5px 0px',
                                }}
                              >
                                {item.qty}
                              </div>
                              <div style={{ display: 'flex', flexDirection: 'column' }}>
                                <div
                                  style={{
                                    fontFamily: 'Roboto Medium',
                                    fontSize: '16px',
                                    color: '#181436',
                                    textTransform: 'capitalize',
                                    letterSpacing: '0.5px',
                                  }}
                                >
                                  {item.item}
                                </div>
                                {item?.promotion && (
                                  <div
                                    style={{
                                      fontFamily: 'Roboto Regular',
                                      fontSize: '13px',
                                      color: '#BABABA',
                                      marginTop: '2px',
                                      marginBottom: '5px',
                                    }}
                                  >
                                    Applied -{' '}
                                    <a
                                      style={{
                                        fontFamily: 'Roboto Medium',
                                        fontSize: '13px',
                                        color: 'rgb(69, 165, 23)',
                                      }}
                                    >
                                      {' '}
                                      {TextTransformation(item?.promotion)}
                                    </a>
                                  </div>
                                )}
                                {isMealItem && (
                                  <div
                                    style={{
                                      fontSize: '12px',
                                      fontFamily: 'Inter Regular',
                                      color: 'lightgray',
                                    }}
                                  >
                                    {' '}
                                    Meal item
                                  </div>
                                )}
                              </div>
                              <div
                                style={{
                                  flex: 1,
                                  textAlign: 'right',
                                  fontFamily: 'Roboto Medium',
                                  fontSize: '14px',
                                  color: '#181436',
                                }}
                              >
                                {' '}
                                {displayPrice}
                              </div>
                            </div>
                            {item?.extra_toppings?.map((t, j) => (
                              <div
                                style={{
                                  display: 'flex',
                                  flexDirection: 'row',
                                  margin: '0px 0px 0px 35px',
                                }}
                                key={t.topping_name}
                              >
                                <div
                                  style={{
                                    fontFamily: 'Roboto Regular',
                                    fontSize: '13px',
                                    color: '#181436',
                                    marginRight: '30px',
                                    textTransform: 'capitalize',
                                    letterSpacing: '0.5px',
                                  }}
                                >{`${t.topping_name} (${t.topping_qty})`}</div>
                                <div
                                  style={{
                                    fontFamily: 'Roboto Regular',
                                    fontSize: '13px',
                                    color: '#181436',
                                    marginRight: '10px',
                                  }}
                                >
                                  ${(t.topping_qty * t.price).toFixed(2)}
                                </div>
                              </div>
                            ))}
                          </div>
                        );
                      })}
                    </div>
                  </div>
                )}

                {isMealOrder === true && Object.keys(clickedOrderReady).length > 0 && (
                  <div style={{ marginTop: '20px' }}>
                    <div
                      style={{
                        marginLeft: '10px',
                        fontFamily: 'Roboto',
                        fontSize: '14px',
                        color: '#929293',
                      }}
                    >
                      Item{clickedOrderReady?.item_names?.length > 1 ? 's' : ''}
                    </div>
                    <div style={{ margin: '10px 10px 10px 15px', alignContent: 'center' }}>
                      {clickedOrderReady?.item_name?.map((item, i) => {
                        let price = 'Meal item';
                        const displayPrice = price === 'Meal item' ? 'Meal item' : `$${price}`;

                        return (
                          <div
                            style={{ alignContent: 'center', marginBottom: '10px' }}
                            key={`${item}_${i}`}
                          >
                            <div
                              style={{
                                display: 'flex',
                                flexDirection: 'row',
                                alignText: 'center',
                                alignContent: 'center',
                              }}
                            >
                              <div
                                style={{
                                  display: 'flex',
                                  fontFamily: 'Roboto Medium',
                                  fontSize: '11px',
                                  justifyContent: 'center',
                                  backgroundColor: '#e8e7e9',
                                  alignItems: 'center',
                                  border: '1px solid #c7c7c7',
                                  borderRadius: '3px',
                                  height: '18px',
                                  width: '22px',
                                  margin: '0px 10px 5px 0px',
                                }}
                              >
                                {item.qty}
                              </div>
                              <div style={{ display: 'flex', flexDirection: 'column' }}>
                                <div
                                  style={{
                                    fontFamily: 'Roboto Medium',
                                    fontSize: '16px',
                                    color: '#181436',
                                    textTransform: 'capitalize',
                                  }}
                                >
                                  {item.item}
                                </div>
                                {item?.promotion && (
                                  <div
                                    style={{
                                      fontFamily: 'Roboto Regular',
                                      fontSize: '11px',
                                      color: '#BABABA',
                                      marginTop: '2px',
                                      marginBottom: '5px',
                                    }}
                                  >
                                    Applied -{' '}
                                    <a
                                      style={{
                                        fontFamily: 'Roboto Medium',
                                        fontSize: '11px',
                                        color: 'rgb(69, 165, 23)',
                                      }}
                                    >
                                      {' '}
                                      {TextTransformation(item?.promotion)}
                                    </a>
                                  </div>
                                )}

                                {item?.product_category && (
                                  <div
                                    style={{
                                      fontSize: '12px',
                                      fontFamily: 'Inter Regular',
                                      color: 'lightgray',
                                    }}
                                  >
                                    Meal item
                                  </div>
                                )}
                              </div>
                              <div
                                style={{
                                  flex: 1,
                                  textAlign: 'right',
                                  fontFamily: 'Roboto Medium',
                                  fontSize: '14px',
                                  color: '#181436',
                                }}
                              >
                                {' '}
                                {price}
                              </div>
                            </div>
                            {item?.extra_toppings?.map((t, j) => (
                              <div
                                style={{
                                  display: 'flex',
                                  flexDirection: 'row',
                                  margin: '0px 0px 0px 35px',
                                }}
                                key={t.topping_name}
                              >
                                <div
                                  style={{
                                    fontFamily: 'Roboto Regular',
                                    fontSize: '13px',
                                    color: '#181436',
                                    marginRight: '30px',
                                    textTransform: 'capitalize',
                                  }}
                                >{`${t.topping_name} (${t.topping_qty})`}</div>
                                <div
                                  style={{
                                    fontFamily: 'Roboto Regular',
                                    fontSize: '13px',
                                    color: '#181436',
                                    marginRight: '10px',
                                  }}
                                >
                                  ${(t.topping_qty * t.price).toFixed(2)}
                                </div>
                              </div>
                            ))}
                          </div>
                        );
                      })}
                    </div>
                  </div>
                )}

                <div style={{ margin: '10px 5px 20px 38%' }}>
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      justifyContent: 'space-between',
                    }}
                  >
                    <div style={StyleTotalBlock}> Sub total</div>
                    <div style={StyleNumberBlock}>
                      {' '}
                      ${(clickedOrderReady?.sub_total || 0.0)?.toFixed(2)}
                    </div>
                  </div>
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      justifyContent: 'space-between',
                    }}
                  >
                    <div style={StyleTotalBlock}> Delivery Fee</div>
                    <div style={StyleNumberBlock}>
                      {' '}
                      $
                      {clickedOrderReady?.delivery_price?.toFixed(2) ||
                        clickedOrderReady?.deliverySubscription_fee?.toFixed(2)}
                    </div>
                  </div>

                  {clickedOrderReady?.discount_coupon_no && (
                    <div>
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'row',
                          justifyContent: 'space-between',
                        }}
                      >
                        <div style={StyleTotalBlock}>Discount</div>
                        <div style={{ ...StyleNumberBlock, color: 'green' }}>
                          {' '}
                          {promoTypeLabel(
                            clickedOrderReady?.discount_type,
                            clickedOrderReady?.discountedAmount
                          )}
                        </div>
                      </div>

                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'row',
                          justifyContent: 'space-between',
                        }}
                      >
                        <div style={StyleTotalBlock}> Discount code</div>
                        <div style={{ ...StyleNumberBlock, textTransform: 'uppercase' }}>
                          {' '}
                          {clickedOrderReady?.discount_coupon_no}
                        </div>
                      </div>
                    </div>
                  )}

                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      justifyContent: 'space-between',
                    }}
                  >
                    <div style={StyleTotalBlock}>Tax & other fee</div>
                    <div style={StyleNumberBlock}>
                      {' '}
                      $
                      {(clickedOrderReady?.tax_plus_serviceFees || clickedOrderReady?.tax)?.toFixed(
                        2
                      )}
                    </div>
                  </div>
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      justifyContent: 'space-between',
                    }}
                  >
                    <div style={StyleTotalBlock}>Tip</div>
                    <div style={StyleNumberBlock}> ${clickedOrderReady?.tip?.toFixed(2)}</div>
                  </div>

                  {clickedOrderReady?.promoOrderAmountAdded_In_Total_charged !== 0 && (
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        marginTop: '10px',
                      }}
                    >
                      <div style={{ display: 'flex', flexDirection: 'column' }}>
                        <div style={{ ...StyleTotalBlock, fontSize: '13px' }}>
                          Complimentary Item
                        </div>
                        <div style={{ fontSize: '12px', color: 'gray' }}>
                          {' '}
                          Packaging & Delivery Fee
                        </div>
                        <div style={{ fontSize: '12px', color: 'green' }}> Arriving Tomorrow</div>
                      </div>

                      <div style={StyleNumberBlock}>
                        {' '}
                        ${clickedOrderReady?.promoOrderAmountAdded_In_Total_charged?.toFixed(2)}
                      </div>
                    </div>
                  )}

                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      justifyContent: 'space-between',
                      marginTop: '10px',
                    }}
                  >
                    <div style={{ ...StyleTotalBlock, fontFamily: 'Inter Bold' }}>Total</div>
                    <div style={{ ...StyleNumberBlock, fontFamily: 'Inter Bold' }}>
                      {' '}
                      ${clickedOrderReady?.total_charged?.toFixed(2)}
                    </div>
                  </div>
                </div>
              </AccordionDetails>
            </Accordion>
          </div>
        </div>
      )}
    </div>
  );
};

export default ReadyOrder;
